import { picoapp } from 'picoapp';
import AppComponents from './AppComponents';
import AppState from './AppState';
import common from './features/common';
import webfonts from './features/webfonts';
import icons from './features/icons';
import welcome from './features/welcome';
import '../sass/theme.scss';

const app = picoapp(AppComponents, AppState);

app.mount(['data-component']);

welcome.init();
window.app = app;
common.init(app);
webfonts.init(app);
icons.init();